import styled from "styled-components";
import Width from "../Width";
import { Box } from "@mui/material";

const FooterBlock = styled.div`
  width: 100%;
  font-size: 12px;
  padding-top: 40px;
  color: #999;
  margin-bottom: 80px;
`;

const FooterZaComponent = () => {
  const year = new Date().getFullYear();

  return (
    <FooterBlock>
      <Width>
        <Box>© 2011 – {year} Turlov Family Office Securities (PTY) LTD</Box>
        <p>
          Turlov Family Office Securities (PTY) LTD is an authorised Financial
          Services Provider (FSP No. 52874) under the Financial Advisory and
          Intermediary Services Act, 2002 (FAIS Act), regulated by the Financial
          Sector Conduct Authority (FSCA) of South Africa. We are approved to
          offer non-automated advice and intermediary services on shares, bonds,
          money market instruments, participatory interests in a hedge
          fund/collective investment scheme, debentures and securitised debt,
          warrants, certificates and other instruments, derivative instruments,
          long-term and short-term deposits in accordance with our licensing
          conditions. There are risks involved in buying or selling any financial
          product. Past performance is not indicative of future performance. The
          value of financial products can increase as well as decrease over time.
          Illustrations, forecasts or hypothetical data are for illustrative
          purposes only.
        </p>
        <p>
          TFOS shall not be held liable for the unauthorized use of its name,
          trademark, logo, or any other corporate symbols by third parties. Any
          information regarding authorized partners who are permitted to use these
          brand elements will be published exclusively on the Company&apos;s
          official website. TFOS shall not be responsible for the actions of third
          parties who falsely claim to be partners or representatives of the
          Company, or who unlawfully use the Company&apos;s name, trademark, logo,
          or any other corporate symbols without proper authorization.
        </p>
        <p>
          The information and materials presented herein are provided for
          informational purposes only and are not intended to constitute financial,
          legal, tax, or any other advice. This information is not intended as an
          offer or solicitation for the purchase or sale of any financial
          instrument. Before selecting a financial product, it is recommended that
          investors seek specialised financial, legal and tax advice.
        </p>
      </Width>
    </FooterBlock>
  );
};

export default FooterZaComponent;
